import React from 'react'
import { useTranslation } from 'react-i18next'

import EmptyState from '..'

import useStyles from '../useStyles'
import { Icon } from 'common/components/base/.raw'

const NoShipmentsFound: React.FC = () => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <EmptyState
      illustration={
        <Icon name="allShipments" className={classes.illustrationIcon} />
      }
      heading={t('EMPTY_SCREENS.THIS_FEATURE_DISABLED')}
      description={t('EMPTY_SCREENS.INVENTORY_SCAN_300_1400')}
    />
  )
}

export default NoShipmentsFound
